"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9037],{

/***/ 14553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ AccountOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const AccountOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 13.9895 4.18351 15.8194 5.32851 17.2676C5.58317 16.4856 6.12054 15.8107 6.85621 15.3914L8.76361 14.2968C8.1448 13.5615 7.772 12.6122 7.772 11.5759V9.83689C7.772 7.50167 9.66479 5.60889 12 5.60889C14.3349 5.60889 16.229 7.50139 16.229 9.83689V11.5759C16.229 12.6132 15.8554 13.5631 15.2354 14.2986L17.1437 15.3908L17.1444 15.3912C17.8805 15.8106 18.4173 16.4856 18.6716 17.2674C19.8165 15.8192 20.5 13.9894 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM10.0133 15.3091C10.6056 15.6249 11.2819 15.8039 12 15.8039C12.7169 15.8039 13.3922 15.6255 13.984 15.3106L16.3999 16.6934L16.4013 16.6942C16.9789 17.0231 17.3365 17.6396 17.3365 18.3075V18.6164C16.8532 19.0067 16.3263 19.3451 15.7642 19.6232C14.9127 19.9671 13.6909 20.2625 12.0005 20.2625C10.3078 20.2625 9.08478 19.9663 8.23289 19.6217C7.67189 19.3439 7.14595 19.006 6.6635 18.6164V18.3075C6.6635 17.6402 7.0216 17.0234 7.59965 16.6942L7.6018 16.693L10.0133 15.3091ZM13.4184 13.9069C14.2043 13.428 14.729 12.5631 14.729 11.5759V9.83689C14.729 8.33038 13.5071 7.10889 12 7.10889C10.4932 7.10889 9.272 8.3301 9.272 9.83689V11.5759C9.272 12.5628 9.79594 13.4273 10.5809 13.9062C10.6523 13.9484 10.7542 14.0035 10.8812 14.0593C11.1657 14.1842 11.5558 14.3035 12.0005 14.3035C12.445 14.3035 12.8341 14.1846 13.1176 14.0602C13.2451 14.0042 13.3472 13.9489 13.4184 13.9069ZM2 12C2 14.9959 3.31741 17.684 5.40452 19.5168L5.42841 19.5438C5.49553 19.6189 5.59114 19.7182 5.71841 19.8332C5.97322 20.0636 6.35385 20.3562 6.88471 20.6435C7.10268 20.7615 7.34486 20.878 7.6128 20.9888C8.93735 21.6364 10.4262 22 12 22C13.5724 22 15.06 21.6371 16.3837 20.9905C16.6532 20.8792 16.8968 20.7621 17.1159 20.6435C17.6466 20.3561 18.0271 20.0635 18.2819 19.8331C18.4091 19.7181 18.5047 19.6187 18.5718 19.5437L18.5956 19.5167C20.6826 17.6839 22 14.9958 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 60912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ BoxOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const BoxOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M21 8.089V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21072 20.0391 3 19.5304 3 19V8.089C2.99962 7.8178 3.0544 7.54936 3.161 7.3L4.481 4.211C4.63541 3.85134 4.89195 3.5449 5.21884 3.32964C5.54573 3.11438 5.9286 2.99976 6.32 3H17.68C18.0717 3.00002 18.4548 3.11507 18.7818 3.33089C19.1087 3.54671 19.365 3.85378 19.519 4.214L20.839 7.3C20.945 7.55 21 7.818 21 8.089Z',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M3 8H20.99',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M14 3L15 8V11.225C14.9881 11.4416 14.891 11.6447 14.7298 11.7899C14.5687 11.9351 14.3567 12.0106 14.14 12H9.86C9.64335 12.0106 9.43129 11.9351 9.27015 11.7899C9.10902 11.6447 9.01189 11.4416 9 11.225V8L10 3',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M6 18H8',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 69254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LocationOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const LocationOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M11.6957 2.75C9.09299 2.75 6.35871 4.72035 6.35871 8.08696C6.35871 8.84669 6.67432 9.80604 7.22598 10.8727C7.76947 11.9236 8.50271 13.0046 9.24942 13.9876C9.99415 14.968 10.7407 15.8358 11.302 16.4592C11.4469 16.6202 11.5792 16.7646 11.6957 16.8901C11.8121 16.7646 11.9444 16.6202 12.0894 16.4592C12.6506 15.8358 13.3972 14.968 14.1419 13.9876C14.8886 13.0046 15.6219 11.9236 16.1654 10.8727C16.717 9.80604 17.0326 8.84669 17.0326 8.08696C17.0326 4.72035 14.2983 2.75 11.6957 2.75ZM11.6957 17.9783C11.1633 18.5065 11.1632 18.5064 11.163 18.5063L11.1627 18.5059L11.1615 18.5048L11.1576 18.5008L11.1432 18.4862L11.0896 18.4313C11.0432 18.3835 10.9758 18.3138 10.8905 18.2241C10.72 18.0447 10.4776 17.7854 10.1872 17.4628C9.60714 16.8185 8.83197 15.9178 8.05496 14.895C7.27993 13.8747 6.49143 12.7177 5.89362 11.5618C5.30398 10.4217 4.85871 9.20548 4.85871 8.08696C4.85871 3.74922 8.41486 1.25 11.6957 1.25C14.9765 1.25 18.5326 3.74922 18.5326 8.08696C18.5326 9.20548 18.0874 10.4217 17.4977 11.5618C16.8999 12.7177 16.1114 13.8747 15.3364 14.895C14.5594 15.9178 13.7842 16.8185 13.2041 17.4628C12.9137 17.7854 12.6713 18.0447 12.5008 18.2241C12.4155 18.3138 12.3482 18.3835 12.3017 18.4313L12.2481 18.4862L12.2338 18.5008L12.2298 18.5048L12.2287 18.5059L12.2283 18.5063C12.2282 18.5064 12.2281 18.5065 11.6957 17.9783ZM11.6957 17.9783L12.2281 18.5065C12.0873 18.6484 11.8956 18.7283 11.6957 18.7283C11.4957 18.7283 11.3041 18.6484 11.1633 18.5065L11.6957 17.9783ZM17.4472 15.2423C17.8177 15.057 18.2682 15.2072 18.4534 15.5777L20.3385 19.3479C20.9203 20.5114 20.0742 21.8805 18.7733 21.8805H4.61804C3.31712 21.8805 2.47101 20.5114 3.05279 19.3479L4.93788 15.5777C5.12313 15.2072 5.57363 15.057 5.94411 15.2423C6.3146 15.4275 6.46477 15.878 6.27952 16.2485L4.39443 20.0187C4.31132 20.1849 4.4322 20.3805 4.61804 20.3805H18.7733C18.9591 20.3805 19.08 20.1849 18.9969 20.0187L17.1118 16.2485C16.9266 15.878 17.0767 15.4275 17.4472 15.2423ZM10.7065 8.08679C10.7065 7.5405 11.1494 7.09766 11.6957 7.09766C12.2419 7.09766 12.6848 7.54051 12.6848 8.08679C12.6848 8.63307 12.2419 9.07592 11.6957 9.07592C11.1494 9.07592 10.7065 8.63307 10.7065 8.08679ZM11.6957 5.59766C10.321 5.59766 9.20654 6.71208 9.20654 8.08679C9.20654 9.4615 10.321 10.5759 11.6957 10.5759C13.0704 10.5759 14.1848 9.4615 14.1848 8.08679C14.1848 6.71208 13.0704 5.59766 11.6957 5.59766Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 97394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ MarkAsReadAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const MarkAsReadAlternativeOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M2.25 5.5C2.25 5.08579 2.58579 4.75 3 4.75H21C21.4142 4.75 21.75 5.08579 21.75 5.5C21.75 5.91421 21.4142 6.25 21 6.25H3C2.58579 6.25 2.25 5.91421 2.25 5.5ZM21.0658 13.2625C21.3587 13.5553 21.3587 14.0302 21.0658 14.3231L16.8232 18.5658C16.5303 18.8586 16.0554 18.8586 15.7625 18.5658L12.9341 15.7373C12.6412 15.4444 12.6412 14.9696 12.9341 14.6767C13.227 14.3838 13.7019 14.3838 13.9948 14.6767L16.2929 16.9748L20.0052 13.2625C20.2981 12.9696 20.773 12.9696 21.0658 13.2625ZM3 8.75C2.58579 8.75 2.25 9.08579 2.25 9.5C2.25 9.91421 2.58579 10.25 3 10.25H21C21.4142 10.25 21.75 9.91421 21.75 9.5C21.75 9.08579 21.4142 8.75 21 8.75H3ZM2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75H8C8.41421 12.75 8.75 13.0858 8.75 13.5C8.75 13.9142 8.41421 14.25 8 14.25H3C2.58579 14.25 2.25 13.9142 2.25 13.5ZM3 16.75C2.58579 16.75 2.25 17.0858 2.25 17.5C2.25 17.9142 2.58579 18.25 3 18.25H8C8.41421 18.25 8.75 17.9142 8.75 17.5C8.75 17.0858 8.41421 16.75 8 16.75H3Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 93747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ NewsOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const NewsOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M2.8335 11.1667L6.16683 8.75V12.985L2.8335 11.1667Z',
                    fill: '#82869E',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M21.1668 11.1667L17.8335 8.75V12.985L21.1668 11.1667Z',
                    fill: '#82869E',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M6.16683 8.75L2.8335 11.1667V21.1667H21.1668V11.1667L17.8335 8.75',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M6.16699 12.9999V2.83325H17.8337V12.9999',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M2.8335 11.1665L21.1668 21.1665',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M21.1667 11.1665L12 16.1665',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M9.5 7H14.5',
                    stroke: '#82869E',
                    strokeWidth: '2',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M9.5 10.3333H14.5',
                    stroke: '#82869E',
                    strokeWidth: '2',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 58258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NotificationsOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const NotificationsOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M5.99398 13V9C5.99398 5.686 8.68298 3 12 3C12.7883 2.99961 13.569 3.15449 14.2975 3.4558C15.0259 3.75712 15.6879 4.19897 16.2456 4.75612C16.8033 5.31327 17.2458 5.97481 17.5479 6.70298C17.8499 7.43115 18.0056 8.21168 18.006 9V13C18.006 13.986 18.454 14.919 19.223 15.537L19.532 15.785C20.449 16.521 19.928 18 18.752 18H5.24798C4.07198 18 3.55098 16.521 4.46798 15.785L4.77698 15.537C5.15686 15.2322 5.46344 14.846 5.67408 14.4069C5.88472 13.9678 5.99404 13.487 5.99398 13V13Z',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M10.5 21H13.5',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 55327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ OrderOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const OrderOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M7.5328 3.5625C7.5328 3.14829 7.86859 2.8125 8.2828 2.8125H15.2308C15.645 2.8125 15.9808 3.14829 15.9808 3.5625V3.80501H19.201C19.6152 3.80501 19.951 4.14079 19.951 4.55501V20.4361C19.951 20.8503 19.6152 21.1861 19.201 21.1861H4.3125C3.89829 21.1861 3.5625 20.8503 3.5625 20.4361V4.55501C3.5625 4.14079 3.89829 3.80501 4.3125 3.80501H7.5328V3.5625ZM15.9808 7.53276V5.30501H18.451V19.6861H5.0625V5.30501H7.5328V7.53276C7.5328 7.94698 7.86859 8.28276 8.2828 8.28276H10.0198C10.434 8.28276 10.7698 7.94698 10.7698 7.53276C10.7698 7.30843 11.0628 6.87111 11.7568 6.87111C12.4508 6.87111 12.7438 7.30843 12.7438 7.53276C12.7438 7.94698 13.0796 8.28276 13.4938 8.28276H15.2308C15.645 8.28276 15.9808 7.94698 15.9808 7.53276ZM9.0328 4.3125V6.78276H9.41784C9.7871 5.89836 10.7889 5.37111 11.7568 5.37111C12.7247 5.37111 13.7265 5.89836 14.0957 6.78276H14.4808V4.3125H9.0328ZM15.4476 12.0333C15.7405 11.7404 15.7405 11.2655 15.4476 10.9726C15.1547 10.6797 14.6798 10.6797 14.3869 10.9726L11.0384 14.3211L9.80564 13.0883C9.51275 12.7954 9.03787 12.7954 8.74498 13.0883C8.45209 13.3812 8.45209 13.8561 8.74498 14.149L10.5081 15.9121C10.6487 16.0527 10.8395 16.1318 11.0384 16.1318C11.2373 16.1318 11.4281 16.0527 11.5688 15.9121L15.4476 12.0333Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 52294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ PhoneOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const PhoneOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M14.9774 13.9669L13.0505 15.8677C12.0457 15.2618 11.1122 14.5448 10.2677 13.7302C9.45438 12.8843 8.73749 11.9507 8.13027 10.9465L10.0292 9.01967C10.2645 8.78079 10.332 8.42345 10.2002 8.11518L8.22027 3.50005C8.0586 3.12393 7.64588 2.92293 7.25008 3.02756L3.61954 3.98784C3.24616 4.08464 2.98926 4.42667 3.00035 4.81223C3.23135 9.03476 4.98702 13.03 7.94127 16.0558C10.9676 19.0109 14.9639 20.767 19.1875 20.9976C19.5736 21.0106 19.9168 20.7535 20.0128 20.3793L20.9722 16.747C21.0773 16.3514 20.8766 15.9385 20.5006 15.7768L15.8846 13.7977C15.5759 13.664 15.217 13.7309 14.9774 13.9669Z',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 1134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);




const StyledContainer = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, ({ fluid }) => {
    const styles = {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: '1rem',
        paddingRight: '1rem',
    };
    if (!fluid) {
        styles.maxWidth = '1264px';
    }
    return styles;
});
const Container = (props) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, Object.assign({}, props));




/***/ }),

/***/ 20321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ getNavItems; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/AccountOutlined.es.js
var AccountOutlined_es = __webpack_require__(14553);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/OrderOutlined.es.js
var OrderOutlined_es = __webpack_require__(55327);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(69254);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/NotificationsOutlined.es.js
var NotificationsOutlined_es = __webpack_require__(58258);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/helpers/IconBase.es.js + 1 modules
var IconBase_es = __webpack_require__(80711);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/UnionPaymentOutlined.es.js


const UnionPaymentOutlined = (props) => {
    return (0,IconBase_es/* GenIcon */.w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 28 28', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M17.9516 13.8602C21.59 13.8602 24.55 10.9009 24.55 7.26339C24.55 3.62589 21.59 0.666672 17.9516 0.666672C14.3132 0.666672 11.3531 3.62594 11.3531 7.26344C11.3531 10.9009 14.3132 13.8602 17.9516 13.8602ZM17.9516 2.22917C20.7285 2.22917 22.9876 4.48756 22.9876 7.26344C22.9876 10.0393 20.7285 12.2977 17.9516 12.2977C15.1748 12.2977 12.9156 10.0393 12.9156 7.26344C12.9156 4.48756 15.1748 2.22917 17.9516 2.22917ZM16.5734 7.21085L18.4006 8.56262C18.6063 8.71476 18.5023 9.05142 18.2423 9.05304L17.6689 9.05653H17.6672C17.5197 9.05653 17.3993 8.93715 17.3984 8.78965C17.3957 8.3582 17.0441 8.00971 16.6124 8.01325C16.1809 8.0159 15.8333 8.36783 15.8359 8.79929C15.8411 9.63288 16.4056 10.3341 17.1705 10.5501V10.5879C17.1705 11.0193 17.5202 11.3691 17.9517 11.3691C18.3831 11.3691 18.7329 11.0193 18.7329 10.5879V10.5485C19.0372 10.4641 19.3159 10.3018 19.5438 10.071C19.8876 9.72273 20.0753 9.26148 20.0719 8.7709V8.76601C20.068 8.19299 19.7906 7.64736 19.3298 7.30653L17.5027 5.95481C17.2952 5.80127 17.4042 5.47044 17.6627 5.47044H18.237C18.3853 5.47044 18.5059 5.5909 18.5059 5.73898C18.5059 6.17043 18.8557 6.52023 19.2871 6.52023C19.7185 6.52023 20.0683 6.17043 20.0683 5.73898C20.0683 4.90122 19.5023 4.19351 18.7328 3.97674V3.93913C18.7328 3.50767 18.383 3.15788 17.9516 3.15788C17.5202 3.15788 17.1704 3.50767 17.1704 3.93913V3.9757C16.399 4.19127 15.8313 4.89986 15.8313 5.73898C15.8314 6.31684 16.1088 6.86705 16.5734 7.21085ZM23.3277 15.0938C24.4257 14.332 25.9511 14.5366 26.7961 15.6244C27.6873 16.771 27.4431 18.4246 26.2606 19.2663L21.1027 22.9351C19.5854 24.0151 17.7992 24.5871 15.9365 24.5896L9.09689 24.8013C9.25606 25.2669 9.00387 25.6871 8.61892 25.8186L4.30856 27.2914C3.90054 27.4308 3.45642 27.2133 3.31679 26.8048L0.708817 19.1766C0.569234 18.7683 0.787359 18.324 1.19543 18.1846L5.5058 16.7117C5.91403 16.5722 6.35798 16.7901 6.49757 17.1983L6.60069 17.4999L6.99871 17.2565C7.46949 16.3876 8.1546 15.6517 8.99215 15.1189C9.92168 14.5277 10.9978 14.2152 12.104 14.2152C13.5778 14.2152 15.0067 14.7851 16.077 15.789H18.1974C19.13 15.789 19.9422 16.3133 20.3552 17.0824L23.3277 15.0938ZM2.44002 19.4105L4.54252 25.5603L7.37434 24.5927L5.27184 18.4429L2.44002 19.4105ZM20.1969 21.662L25.3549 17.9931C25.8129 17.6671 25.9072 17.0268 25.5623 16.583C25.2353 16.1621 24.643 16.0808 24.2154 16.3795L24.2024 16.3884L20.5763 18.8142C20.4719 19.2467 20.2507 19.6437 19.9279 19.9664C19.4665 20.4285 18.8517 20.6833 18.1974 20.6833H13.7897C13.3582 20.6833 13.0085 20.3335 13.0085 19.9021C13.0085 19.4706 13.3582 19.1208 13.7897 19.1208H18.1974C18.6922 19.1208 19.0826 18.7188 19.0826 18.2361C19.0826 17.7482 18.6855 17.3513 18.1974 17.3513H15.7555C15.5508 17.3513 15.3366 17.2646 15.1876 17.1067C14.3781 16.2496 13.283 15.7776 12.104 15.7776C10.4724 15.7776 9.0121 16.688 8.29309 18.1535C8.23121 18.2796 8.12981 18.3961 8.00012 18.4754L7.99955 18.4759L7.11856 19.0146L8.56804 23.2544L15.9 23.0274C15.908 23.0272 15.9161 23.0271 15.9241 23.0271C17.4647 23.0271 18.9422 22.555 20.1969 21.662Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/NewsOutlined.es.js
var NewsOutlined_es = __webpack_require__(93747);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/BoxOutlined.es.js
var BoxOutlined_es = __webpack_require__(60912);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/MarkAsReadAlternativeOutlined.es.js
var MarkAsReadAlternativeOutlined_es = __webpack_require__(97394);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/PhoneOutlined.es.js
var PhoneOutlined_es = __webpack_require__(52294);
;// CONCATENATED MODULE: ./constants/nav-items.tsx



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var NAV_ITEMS = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
            size: 18
        }),
        text: 'Th\xf4ng tin t\xe0i khoản',
        href: '/account',
        contentName: 'viewAccountInfo',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderOutlined_es/* OrderOutlined */.y, {
            size: 18
        }),
        text: 'Quản l\xfd đơn h\xe0ng',
        href: '/account/orders',
        contentName: 'viewOrder',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
            size: 18
        }),
        text: 'Sổ địa chỉ',
        href: '/account/addresses',
        contentName: 'viewAddressList',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsOutlined_es/* NotificationsOutlined */.Z, {
            size: 18,
            className: "noti"
        }),
        text: 'Th\xf4ng b\xe1o',
        href: '/notification',
        anonymous: true,
        showByConfiguration: true,
        contentName: 'viewNotification',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnionPaymentOutlined, {
            size: 18
        }),
        text: 'Điểm th\xe0nh vi\xean',
        href: '/my/loyalty-history',
        contentName: 'viewLoyalty',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsOutlined_es/* NewsOutlined */.l, {
            size: 18
        }),
        text: 'Bản tin',
        href: '/account/notifications',
        contentName: 'viewNotifications',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxOutlined_es/* BoxOutlined */.h, {
            size: 18
        }),
        text: 'Tồn kho v\xe0 xuất b\xe1n',
        href: '/account/sellout',
        contentName: 'viewSellout',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkAsReadAlternativeOutlined_es/* MarkAsReadAlternativeOutlined */.X, {
            size: 18
        }),
        text: 'Danh s\xe1ch b\xe1o c\xe1o',
        href: '/account/reports',
        contentName: 'viewReports',
        regionName: 'headerBar'
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneOutlined_es/* PhoneOutlined */.L, {
            size: 18
        }),
        text: 'Li\xean hệ Masan',
        href: '/customer-care',
        contentName: 'viewFeedback',
        regionName: 'headerBar'
    }, 
];
var SHARED_NAV_ITEMS = NAV_ITEMS.slice(0, 5);
var PV_NAV_ITEMS = NAV_ITEMS.slice(0, 6);
var MASAN_DEALER_NAV_ITEMS = _toConsumableArray(NAV_ITEMS.slice(0, 4)).concat(_toConsumableArray(NAV_ITEMS.slice(6, 8)));

// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(17963);
;// CONCATENATED MODULE: ./helpers/navigation-bar.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var getNavByTenant = function(tenant) {
    switch(tenant){
        case 'phongvu':
            return PV_NAV_ITEMS;
        case 'masan-dealer':
            return MASAN_DEALER_NAV_ITEMS;
        default:
            return SHARED_NAV_ITEMS;
    }
};
var getNavItems = function(config) {
    var tenant = config.tenant, logged = config.logged, isLoyaltyMember = config.isLoyaltyMember, showNotificationItem = config.showNotificationItem;
    var _navItems = getNavByTenant(tenant);
    if (!logged) {
        _navItems = _navItems.filter(function(nav) {
            return nav.anonymous;
        });
    }
    if (logged && !isLoyaltyMember) {
        _navItems = _navItems.filter(function(nav) {
            return nav.contentName != 'viewLoyalty';
        });
    }
    return _navItems.filter(function(nav) {
        return !nav.showByConfiguration || nav.showByConfiguration && showNotificationItem;
    }).map(function(item) {
        return _objectSpread({}, item, {
            text: (0,i18n.t)(item.text)
        });
    });
};


/***/ }),

/***/ 91277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useLoyalty; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89703);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43476);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12354);




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useLoyalty = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), loyaltyMemberInfo = ref[0], setLoyaltyMemberInfo = ref[1];
    var loyaltyNetworkConfig = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)().loyaltyNetworkConfig;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loadingLoyaltyData = ref1[0], setLoadLoyaltyData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), redemptionCode = ref2[0], setRedemptionCode = ref2[1];
    var ref3 = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)(), terraService = ref3.terraService, loyaltyService = ref3.loyaltyService;
    var getData = function() {
        var _ref = _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var loyaltyClientId, data, encryptedMemCode;
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoadLoyaltyData(true);
                        loyaltyClientId = loyaltyService.networkClientId;
                        if (!loyaltyClientId) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 6;
                        return terraService.getLoyaltyMemberInfo(loyaltyClientId);
                    case 6:
                        data = _ctx.sent.data;
                        setLoyaltyMemberInfo(data);
                    case 8:
                        _ctx.next = 10;
                        return loyaltyService.getEncryptedMembershipCode();
                    case 10:
                        encryptedMemCode = _ctx.sent;
                        setRedemptionCode(encryptedMemCode);
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(_ctx.t0);
                    case 17:
                        _ctx.prev = 17;
                        setLoadLoyaltyData(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14,
                    17,
                    20
                ]
            ]);
        }));
        return function getData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getData();
    }, []);
    return {
        loyaltyMemberInfo: loyaltyMemberInfo,
        networkConfig: loyaltyNetworkConfig,
        loadingLoyaltyData: loadingLoyaltyData,
        redemptionCode: redemptionCode
    };
};


/***/ })

}]);